import { render, staticRenderFns } from "./developmentHistory.vue?vue&type=template&id=0ccf2b05&scoped=true&"
import script from "./developmentHistory.vue?vue&type=script&lang=js&"
export * from "./developmentHistory.vue?vue&type=script&lang=js&"
import style0 from "./developmentHistory.vue?vue&type=style&index=0&id=0ccf2b05&prod&lang=scss&"
import style1 from "./developmentHistory.vue?vue&type=style&index=1&id=0ccf2b05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccf2b05",
  null
  
)

export default component.exports